import type {Agent} from 'services/agent/types';
import type {MergeSuggestion} from 'services/mergeSuggestions/types';
import {Builder} from 'services/utils';

const mapNamevariant = (
  params:
    | {
        name?: string;
        surName?: string;
      }
    | undefined,
): string => {
  return !params
    ? ''
    : (new Builder(params.surName).add(', ', params.name).value ?? '');
};

export const applyAgentTitlesToMergeSuggestions = (
  data: MergeSuggestion[],
  agents: Agent[],
): MergeSuggestion[] => {
  if (agents.length === 0) {
    return data;
  }

  return (data ?? []).map(d => {
    return {
      ...d,
      sourceName: mapNamevariant(
        agents.find(s => s.id === d.sourceId)?.nameVariants?.[0],
      ),
      targetName: mapNamevariant(
        agents.find(s => s.id === d.targetId)?.nameVariants?.[0],
      ),
    };
  });
};
